module.exports = __webpack_public_path__ + "static/media/session-expire.f763958b.svg";